<template>
  <div class="global-container">
    <div class="space-3"></div>
    <div class="footer__wrapper">
      <div class="footer__content">
        <div class="col">
          <p>Links</p>
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/ueberuns">Über uns</router-link></li>
            <li>
              <router-link to="/projekte">Projekte</router-link>
            </li>

            <li>
              <a href="mailto:kurt@helpingheads.at?cc=sina@helpingheads.at"
                >Kontakt</a
              >
            </li>
          </ul>
        </div>
        <div class="col">
          <p>Socials</p>
          <ul class="social-media">
            <li>
              <a
                href="https://www.facebook.com/profile.php?id=100091342603125&locale=de_DE"
                target="_blank"
                aria-label="Facebook"
                >Facebook</a
              >
            </li>
            <li>
              <a
                href="https://www.instagram.com/helping.heads/"
                target="_blank"
                aria-label="Instagram"
                >Instagram</a
              >
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/helping-heads-projektentwicklung-a34154336/"
                target="_blank"
                aria-label="LinkedIn"
                >LinkedIn</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="footer__grey">
        <p class="copyright">© {{ currentYear }} helping heads</p>
        <div class="footer-grey-right">
          <router-link to="/impressum">Impressum</router-link>
          <router-link to="/Datenschutz">Datenschutz</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped lang="scss">
.footer__wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: map-get($spaces, "xl");
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
  .footer__content {
    display: flex;
    gap: map-get($spaces, "xxl");
    @media (max-width: 768px) {
      gap: map-get($spaces, "lg");
    }
    .col {
      p {
        margin-bottom: map-get($spaces, "xxs");
        color: $text--muted;
        font-size: 1rem;
      }
      ul {
        li {
          list-style-type: none;
          a {
            color: $text--greyed;
            line-height: 1.3;
            @media (min-width: 768px) {
              line-height: 1.5;
            }
            cursor: pointer;
            transition: all 0.3s ease;
            &:hover {
              color: $brand--col;
              transition: all 0.3s ease-in-out;
            }
          }
        }
      }
    }
  }
  .footer__grey {
    display: flex;
    align-items: center;
    gap: map-get($spaces, "sm");
    .footer-grey-right {
      display: flex;
      gap: map-get($spaces, "sm");
    }
    @media (max-width: 768px) {
      justify-content: space-between;
      width: 100%;
    }
    a,
    p {
      color: $text--muted;
      font-size: 1rem;
      @media (max-width: 500px) {
        font-size: 0.8rem;
      }
    }
    a {
      text-decoration: underline;
      cursor: pointer;
    }
    .links {
      display: flex;
      gap: map-get($spaces, sm);
    }
  }
}
</style>
